<template>
  <simple-page header="我的设备" @query="query">
    <template #buttons>
      <el-button type="primary" icon="fa fa-download" :loading="loading" @click="download">导出</el-button>
    </template>
    <template #form>
      <el-form inline>
        <el-form-item label="所属单位">
          <comp-select v-model="queryForm.compId" @change="query" style="width: 150px"></comp-select>
        </el-form-item>
        <el-form-item label="所属区域">
          <area-cascader v-model="areaCodes" @change="areaChange"></area-cascader>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model.trim="queryForm.deviceName" clearable
                    placeholder="请输入设备编码或设备名称"
                    @keyup.enter.native="query"
                    style="width: 150px"></el-input>
        </el-form-item>
        <el-form-item label="在线">
          <el-radio v-model="queryForm.online" label="" @change="query">全部</el-radio>
          <el-radio v-model="queryForm.online" :label="true" @change="query">在线</el-radio>
          <el-radio v-model="queryForm.online" :label="false" @change="query">离线</el-radio>
        </el-form-item>
      </el-form>
    </template>
    <template #formMore>
      <el-form inline>
        <el-form-item label="设备类型">
          <code-select v-model="queryForm.deviceType" code-type="DEVICE_TYPE" @change="query" style="width: 150px"></code-select>
        </el-form-item>
        <el-form-item label="机房类型">
          <code-select v-model="queryForm.roomType" code-type="ROOM_TYPE" @change="query" style="width: 150px"></code-select>
        </el-form-item>
        <el-form-item label="告警">
          <code-select v-model="queryForm.warningType" code-type="WARNING_TYPE" @change="query"></code-select>
        </el-form-item>
      </el-form>
    </template>
    <el-table stripe :data="records" :border="true"
              v-loading="loading"
              row-key="deviceCode"
              @selection-change="handleDeviceSelect"
              @sort-change="handleSortChange">
      <el-table-column type="selection" reserve-selection label="选择" width="40" align="center"></el-table-column>
      <column-index></column-index>
      <el-table-column prop="online" label="在线" align="center" width="50" v-slot="{row}">
        <i v-if="row.online" class="fa fa-chain color-success" title="在线"></i>
        <i v-else class="fa fa-chain-broken color-error" title="离线"></i>
      </el-table-column>
      <el-table-column prop="deviceCode" label="设备编号" width="140" sortable="custom" v-slot="{row}">
        <el-link type="primary" @click="showDevice(row)">{{row.deviceCode}}</el-link>
      </el-table-column>
      <el-table-column prop="deviceName" label="设备名称" min-width="150" sortable="custom"></el-table-column>
      <el-table-column prop="areaName" label="所属地区" align="center" min-width="150"></el-table-column>
      <el-table-column prop="address" label="地址" min-width="150" sortable="custom"></el-table-column>
      <el-table-column prop="inFanCount" label="新风台数" align="center" width="60"></el-table-column>
      <column-code-type code-type="DEVICE_TYPE" prop="deviceType" label="设备类型" align="center" min-width="60"></column-code-type>
      <column-code-type code-type="ROOM_TYPE" prop="roomType" label="机房类型" align="center" min-width="60"></column-code-type>
      <el-table-column prop="compName" label="所属单位" min-width="150"></el-table-column>
      <el-table-column prop="acUnion" label="空调联动" align="center" width="80" v-slot="{row}">
        <span v-if="row.acUnion" class="color-success">联动</span>
        <span v-else class="color-gray">不联动</span>
      </el-table-column>
      <el-table-column prop="kwh" label="电表" align="center" width="60"></el-table-column>
      <!--        <el-table-column prop="clothLeftTime" label="无纺布剩余(天)" align="center" width="80">-->
      <!--          <template slot-scope="{ row }">-->
      <!--            <span v-if="row.clothLeftTime === undefined">-</span>-->
      <!--            <span v-else :class="row.clothLeftTime < 30*24 ? 'color-error':''">{{Math.round(row.clothLeftTime/24)}}</span>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
      <!--        <el-table-column prop="lat" label="坐标" align="center" width="60">-->
      <!--          <template slot-scope="{ row }">-->
      <!--            <el-button v-if="!!row.lat" type="text" icon="fa fa-map-marker" @click="showMap(row)" style="font-size: 16px"></el-button>-->
      <!--          </template>-->
      <!--        </el-table-column>-->
<!--        <el-table-column prop="powerOff" label="强制关机" align="center" width="60" v-slot="{row}">
        <el-switch v-model="row.powerOff" @change="savePowerOff(row)"></el-switch>
      </el-table-column>-->
      <column-valid prop="valid"></column-valid>
      <el-table-column prop="fanRunning" label="新风" align="center" width="60" v-slot="{row}">
        <span v-if="row.fanRunning" class="color-success">运行</span>
        <span v-else class="color-gray">停止</span>
      </el-table-column>
      <el-table-column prop="acRunning" label="空调" align="center" width="60" v-slot="{row}">
        <span v-if="!row.acUnion" class="color-gray">--</span>
        <span v-else-if="row.acRunning" class="color-success">运行</span>
        <span v-else class="color-gray">停止</span>
      </el-table-column>
      <el-table-column prop="warningInfo" label="告警信息" align="center" min-width="150" v-slot="{row}">
        <div v-if="row.emergencyStop" class="color-error">消防急停</div>
        <div v-if="row.highTemp" class="color-error">高温告警</div>
        <div v-if="row.highWet" class="color-error">湿度告警</div>
        <div v-if="row.sensorError" class="color-error">传感器异常</div>
        <div v-if="row.kwhOffline" class="color-error">电表离线</div>
        <div v-if="row.fanError" class="color-error">交流风机故障</div>
        <div v-if="row.acError" class="color-error">空调从机失联</div>
        <div v-if="row.clothLeftTime < 48" class="color-warning">无纺布更换提醒</div>
      </el-table-column>
      <el-table-column prop="action" label="操作" width="80" align="center" fixed="right" v-slot="{row}">
        <el-button type="text" icon="fa fa-list" title="运行统计" @click="showDayInfo(row)" style="font-size: 16px"></el-button>
      </el-table-column>
    </el-table>
    <div style="display: flex;align-items: center;justify-content: space-between;padding: 10px 0">
      <div>
        已选中
        {{selectedDevices.length}}
        条
      </div>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>
    </div>

    <map-choose-dialog title="位置查看" :visible.sync="mapVisible"
                       v-if="mapVisible" width="90vw"
                       :lng="device.lng"
                       :lat="device.lat"
                       @close="mapVisible = false"></map-choose-dialog>

    <device-edit-dialog title="设备编辑"
                        :visible.sync="editing"
                        v-if="editing"
                        :device="device"
                        @close="editing=false"
                        @save="onSave"></device-edit-dialog>

    <device-setting-dialog :visible="true"
                           :device-code="deviceCodes" v-if="!!deviceCodes && settingVisible"
                           width="80vw" title="设备参数设置"
                           @close="settingVisible=false"></device-setting-dialog>
  </simple-page>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import MapChooseDialog from "@/components/base/MapChooseDialog";
import DeviceEditDialog from "@/components/device-view/DeviceEditDialog";
import CodeSelect from "@/components/base/CodeSelect";
import CompSelect from "@/components/base/CompSelect.vue";
import * as querystring from "querystringify";
import DeviceSettingDialog from "@/components/device-view/DeviceSettingDialog.vue";
import SimplePage from "@/components/page/SimplePage.vue";
import ColumnIndex from "@/components/tableColumns/ColumnIndex.vue";
import ColumnCodeType from "@/components/tableColumns/ColumnCodeType.vue";
import ColumnValid from "@/components/tableColumns/ColumnValid.vue";
import AreaCascader from "@/components/base/AreaCascader.vue";
import SessionStore from "@/utils/SessionStore";
export default {
  name: 'MyDeviceList',
  components: {
    AreaCascader,
    ColumnValid,
    ColumnCodeType,
    ColumnIndex,
    SimplePage,
    DeviceSettingDialog, CompSelect, CodeSelect, DeviceEditDialog, MapChooseDialog, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      mapVisible: false,
      editing: false,
      multiEditing: false,
      settingVisible: false,
      selectedDevices: [],
      deviceCodes: "",
      user: {},
      areaCodes: [],
      queryForm: {
        deviceName: '',
        online: '',
        warningType: '',
        page: 1,
        limit: 10,
        //排序
        sortBy: null,
        sortType: null
      },
      total: 0,
      records: [],
      device: null
    }
  },
  created() {
    //重置缓存
    let cache = this.getComponentCache();
    if(!cache) {
        if(this.$route.query.online) {
            this.queryForm.online = this.$route.query.online == "true";
        }
        this.queryForm.warningType = this.$route.query.warningType || '';
    }else{
        this.queryForm = cache;
    }
    this.user = SessionStore.getUser();
    if(!this.user.superAdmin && !this.user.roles.find(r=>r.roleCode === "super_admin")) {
      if(this.user.company.provCode) {
        this.areaCodes.push(this.user.company.provCode);
        if(this.user.company.cityCode) {
          this.areaCodes.push(this.user.company.cityCode);
        }
      }
    }
    this.loadData();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device/v2/myDeviceList", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    handleSortChange({column, prop, order}) {
      if(order == null) {
        this.queryForm.sortBy = null;
        this.queryForm.sortType = null;
      } else {
        this.queryForm.sortBy = prop;
        this.queryForm.sortType = (order === "ascending" ? "asc" : "desc")
      }
      this.query();
    },
    showMap(row){
      this.device = row;
      this.mapVisible = true
    },
    //详情页
    showDevice(device) {
      this.saveCache();
      this.$router.push({
        path: "/deviceView",
        query: {
          deviceCode: device.deviceCode
        }
      });
    },

    edit(row) {
      this.device = Object.assign({
        valid: true,
        deviceType: '1',
        inFanCount: 1,
        outFanCount: 1,
        acCount: 1
      }, row || {});
      this.editing = true;
    },
    onSave(){
      this.editing = false;
      this.query();
    },
    handleDeviceSelect(data) {
      this.selectedDevices = data;
    },
    showDayInfo(row) {
      this.saveCache();
      this.$router.push({
        path: "/deviceDayInfo",
        query: {
          deviceCode: row.deviceCode
        }
      })
    },
    saveCache() {
      this.setComponentCache(this.queryForm);
    },
    savePowerOff(row) {
      this.postForm("/device/powerOff", {
        deviceCode: row.deviceCode,
        powerOff: row.powerOff
      })
    },
    download() {
      let params = querystring.stringify(this.queryForm || {});
      window.open(this.globalConfig.apiRoot+"/device/export?"+params);
    },
    multiSetting() {
      let deviceCodes = [];
      this.selectedDevices.forEach(record=>{
        deviceCodes.push(record.deviceCode);
      });
      if(!deviceCodes.length) {
        this.$message.info("请勾选你要批量设置参数的设备");
        return;
      }
      this.deviceCodes = deviceCodes.join(",");
      this.settingVisible = true;
    },
    areaChange(){
      if(this.areaCodes.length > 0) {
        this.queryForm.provCode = this.areaCodes[0];
        this.queryForm.cityCode = this.areaCodes[1];
        this.queryForm.townCode = this.areaCodes[2];
      } else {
        this.queryForm.provCode = null;
        this.queryForm.cityCode = null;
        this.queryForm.townCode = null;
      }
      this.query();
    }
  }
}
</script>

<style scoped>

</style>